import * as React from 'react';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import Checkbox from '@mui/material/Checkbox';
import IconButton from '@mui/material/IconButton';
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';
import { GetString } from './StringResourceManager';
import { Typography } from '@material-ui/core';

interface Props {
  data?: string[] | null;
  buttonEnable?: boolean;
  handleCheckBoxEnable: (selectedItem: string[]) => void;
  handleToggleSelectAll: () => void;
  selectedItems?: string[];
  disabled?: boolean;
  arrowButtonClick?: (selectedItem: string) => void;
  listBoxHeight?: number;
  ListItemFontSize?: number;
}

const ListBox: React.FC<Props> = ({
  data,
  buttonEnable,
  handleCheckBoxEnable,
  handleToggleSelectAll,
  selectedItems,
  disabled,
  arrowButtonClick,
  listBoxHeight,
  ListItemFontSize,
}): React.ReactElement => {
  const handleToggleItem = (value: any) => () => {
    handleCheckBoxEnable(value);
  };

  const arrowButtonOnClick = (value: string) => () => {
    if (arrowButtonClick) {
      arrowButtonClick(value);
    }
  };

  return (
    <List
      sx={{
        width: '100%',
        maxWidth: 360,
        bgcolor: 'background.paper',
        height: listBoxHeight ? listBoxHeight : 300,
        overflow: 'auto',
      }}
    >
      <ListItem disablePadding>
        <ListItemButton
          role={undefined}
          onClick={handleToggleSelectAll}
          disabled={disabled}
        >
          <ListItemIcon>
            <Checkbox
              edge="start"
              tabIndex={-1}
              checked={selectedItems?.length === data?.length}
              disabled={disabled}
            />
          </ListItemIcon>
          <ListItemText
            primary={
              <Typography
                style={{ fontSize: ListItemFontSize ? ListItemFontSize : 18 }}
              >
                {GetString('SELECT_ALL')}
              </Typography>
            }
          />
        </ListItemButton>
      </ListItem>
      {data?.map(value => {
        return (
          <ListItem
            key={value}
            secondaryAction={
              buttonEnable ? (
                <IconButton
                  edge="end"
                  onClick={arrowButtonOnClick(value)}
                  disabled={
                    !selectedItems?.includes(value) || selectedItems.length > 1
                  }
                >
                  <KeyboardArrowRightIcon />
                </IconButton>
              ) : null
            }
            disablePadding
          >
            <ListItemButton
              role={undefined}
              onClick={handleToggleItem(value)}
              dense
              disabled={disabled}
            >
              <ListItemIcon>
                <Checkbox
                  edge="start"
                  tabIndex={-1}
                  disableRipple
                  checked={selectedItems?.includes(value)}
                  disabled={disabled}
                />
              </ListItemIcon>
              <ListItemText
                primary={
                  <Typography
                    style={{
                      fontSize: ListItemFontSize ? ListItemFontSize : 18,
                    }}
                  >
                    {value}
                  </Typography>
                }
              />
            </ListItemButton>
          </ListItem>
        );
      })}
    </List>
  );
};

export default ListBox;
